export default "__VITE_ASSET__3708b720__"